import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import type { LinkProps } from "@casino/legacy/client/shared/NextLink";
import SeeAllLink from "@casino/legacy/client/shared/PageSection/SectionTitle/SeeAllLink";

type Props = {
  href?: LinkProps["href"];
};

const SeeAllLinkPlaceholder: FC<Props> = ({ href }) => {
  const router = useRouter();
  const hrefToString = href?.toString();
  const showSeeAll = router.pathname.includes(hrefToString || "");

  if (href && !showSeeAll) {
    return (
      <SeeAllLink href={href}>
        <p className="text-sm/6 font-medium">
          <Translate id="casino.see_all" />
        </p>
      </SeeAllLink>
    );
  }
  return null;
};

export default SeeAllLinkPlaceholder;
